import { type CSSProperties, useState } from "react";

export type Action = {
  text: string;
  onClick: () => void;
};

type Props = {
  apiEndpointPrefix: string | undefined;
  commitId: string;
  color: string | undefined;
  actions?: Action[];
};
export function DevBar({
  apiEndpointPrefix,
  commitId,
  color,
  actions = [],
}: Props) {
  const [open, setOpen] = useState(true);

  if (!color || !open) {
    return null;
  }

  return (
    <div style={getOuterStyle(color)}>
      <div>{apiEndpointPrefix}</div>
      {actions.map((action) => (
        <button
          key={action.text}
          type="button"
          style={actionButtonStyle}
          onClick={action.onClick}
        >
          {action.text}
        </button>
      ))}
      <div style={rightSectionStyle}>
        <div>
          {commitId === "local build" ? (
            commitId
          ) : (
            <a
              style={commitStyle}
              href={`https://bitbucket.org/directpojistovna/fidoo-fx-fe/commits/${commitId}`}
              target="_blank"
              rel="noreferrer"
            >
              commit
            </a>
          )}
        </div>
        <div style={xStyle} onClick={() => setOpen(false)}>
          x
        </div>
      </div>
    </div>
  );
}

const getOuterStyle = (color: string): CSSProperties => ({
  position: "fixed",
  zIndex: 1000000,
  height: "15px",
  width: "100%",
  display: "flex",
  alignItems: "center",
  gap: "10px",
  padding: "1px 4px",
  color: "white",
  fontSize: "12px",
  lineHeight: "12px",
  fontWeight: "bold",
  background: color,
});

const rightSectionStyle: CSSProperties = {
  marginLeft: "auto",
  display: "flex",
  gap: "10px",
};

const xStyle: CSSProperties = {
  cursor: "pointer",
};

const commitStyle: CSSProperties = {
  color: "white",
  textDecoration: "none",
};

const actionButtonStyle: CSSProperties = {
  background: "transparent",
  border: "none",
  color: "white",
  fontSize: "12px",
  fontWeight: "bold",
  padding: "0 4px",
  cursor: "pointer",
  opacity: 0.9,
};
